/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback } from 'react';
import DeleteFiltersModal from '@jira/global-pages__directories-filters-directory-v2-delete-filters-modal/src/index.tsx';
import { useFlagService } from '@atlassian/jira-flags';
import { useQueryParam, useRouterActions } from '@atlassian/react-resource-router';
/* eslint-disable jira/i18n/no-export-define-message */
/* eslint-disable jira/filename-case */
// eslint-disable-next-line no-restricted-imports
import { defineMessage } from '@atlassian/jira-intl';

const filterDeletedModalTitleSuccessNonFinal = defineMessage({
	id: 'navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-success-non-final',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: '{name} was deleted',
	description: 'Title of the flag shown when the request for deleting a filter succesed',
});

const filterDeletedModalTitleErrorNonFinal = defineMessage({
	id: 'navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-title-error-non-final',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: "We couldn't delete filter",
	description:
		'Title of the flag shown in Filters Directory when the request for deleting a filter failed',
});

const filterDeletedModalDescriptionErrorNonFinal = defineMessage({
	id: 'navigation-apps-sidebar-nav4-filters.common.filter-actions.delete-filter-modal.filter-deleted-modal-description-error-non-final',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'There was an error, please try again.',
	description:
		'Message shown in the flag displayed in Filters Directory when the request for deleting a filter failed',
});

export type Props = {
	isOpen: boolean;
	name: string;
	filterId: string;
	onClose: () => void;
	onRefetch: (options: { onComplete: () => void }) => void;
};
export const DeleteFilterModal = ({
	isOpen,
	name,
	filterId,
	onClose,
	onRefetch,
}: Props): false | React.JSX.Element => {
	const { showFlag } = useFlagService();

	const { push } = useRouterActions();
	const [filterQueryParam] = useQueryParam('filter');

	const onSuccess = useCallback(() => {
		onRefetch({ onComplete: () => undefined });

		if (filterQueryParam === filterId) {
			push('/jira/filters');
		}

		onClose();

		showFlag({
			id: 'filter-deleted',
			title: [filterDeletedModalTitleSuccessNonFinal, { name }],
			type: 'success',
			// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
			messageId:
				'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.success',
			messageType: 'transactional',
		});
	}, [filterId, filterQueryParam, name, onClose, onRefetch, push, showFlag]);

	const onFailure = useCallback(() => {
		onClose();
		showFlag({
			id: 'filter-delete-failed',
			title: filterDeletedModalTitleErrorNonFinal,
			description: filterDeletedModalDescriptionErrorNonFinal,
			type: 'error',
			// eslint-disable-next-line jira/choreographer/message-id-by-folder-structure
			messageId:
				'navigation-apps-sidebar-nav4-sidebars-content-filters.common.ui.filter-actions.delete-filter-modal.show-flag.error',
			messageType: 'transactional',
		});
	}, [onClose, showFlag]);

	const filter = { name, id: filterId };

	return (
		isOpen && (
			<DeleteFiltersModal
				filter={filter}
				onFilterDeleted={onSuccess}
				onFilterDeleteFailed={onFailure}
				onFilterInitiateFailed={onFailure}
				onCancel={onClose}
			/>
		)
	);
};
